<template>
  <!-- SECTION DashboardPage-->
  <div id="DashboardPageSection" class="row col-12 m-0 p-0 no-selection bg-black" v-if="!display.configurationView"
    style="height: calc(100vh - 10px);">
    <div class="row col-12 p-0 m-0 section-container justify-content-center">
      <div class="col-12 m-0 overflow-hidden justify-content-center bg-black rounded-5 p-0" style="height: 100%;">
        <div class="row col-lg-12 col-md-12 col-12 m-0 p-0 pb-0">
          <div class="position-sticky col-12 m-0 p-1 ps-4 bg-black text-white text-start">
            <div class="row col-12 p-0 m-0">
              <!--Primera sección-->
              <div class="row col-8 m-0 pt-0 ps-3 pe-4 text-white">
                <div class="col m-0 pt-0 ps-0 text-white d-flex flex-row">
                  <h6 class="tx-left tx-14 text-white m-0 p-0 pe-4 mt-1 pt-1 d-flex flex-row">
                    <ion-icon name="location" class="tx-18 me-2 align-bottom"></ion-icon>
                    {{ dictionary["Empresa"][session.user.language] }}
                  </h6>
                  <select v-if="this.$route.params.currentDisplay === 'dashboardcomp' || this.targetEmplacementId == ''"
                    :value="currentCompany.nifCif" class="form-control m-0 p-0 text-nowrap bg-white border me-3"
                    style="border: solid 2px white ; color: black; min-width:110px; max-width: 240px; height: 34px;"
                    @change="onCurrentCompanyChanged">
                    <option v-if="availableCompanies[0] != undefined && availableCompanies.length > 1" value="showAll">
                      {{ dictionary['Mostrar todo'][session.user.language] }} </option>
                    <option v-for="company in availableCompanies" :key="company.nifCif" :v-if="company.nifCif != session.user.nifCif
                      && company.relation != undefined
                      && company.relation.referenceCompany === this.session.user.nifCif" :value="company.nifCif">
                      {{ (company.nifCif === session.user.nifCif) ? "✪ " + company.name : company.name }}
                    </option>
                  </select>
                  <h6 class="tx-left tx-14 text-white m-0 p-0 pe-4 mt-1 pt-1 d-flex flex-row">
                    <ion-icon name="location" class="tx-18 me-2 align-bottom"></ion-icon>
                    {{ dictionary["Emplazamiento"][session.user.language] }}
                  </h6>
                  <select v-if="this.$route.params.currentDisplay === 'dashboardcomp'" :value="targetEmplacementId"
                    class="form-control m-0 p-0 text-nowrap bg-white border me-3"
                    style="border: solid 2px white ; color: black; min-width:110px; max-width: 240px; height: 34px;"
                    @change="onEmplacementChanged">
                    <option v-for="emplacement in emplacementList" :key="emplacement.nifCif" :value="emplacement.id">
                      {{ emplacement.label }}
                    </option>
                  </select>
                  <h6 class="tx-left tx-14 text-white m-0 p-0 pe-4 mt-1 pt-1 d-flex flex-row">
                    <ion-icon name="arrow-up-circle" class="tx-18 me-2 align-bottom"></ion-icon>
                    {{ dictionary["Prioridad"][session.user.language] }}
                  </h6>
                  <select v-if="this.$route.params.currentDisplay === 'dashboardcomp'" :value="priority"
                    class="form-control m-0 p-0 text-nowrap bg-white border me-3"
                    style="border: solid 2px white ; color: black; min-width:110px; max-width: 240px; height: 34px;"
                    @change="onPriorityChanged">
                    <option value="None">
                      {{ dictionary["Ninguna"][session.user.language] }}
                    </option>
                    <option value="Presure">
                      {{ dictionary["Cambios de presión"][session.user.language] }}
                    </option>
                    <option value="Warning">
                      {{ dictionary["Avisos"][session.user.language] }}
                    </option>
                  </select>
                </div>

              </div>

              <!--Segunda sección-->
              <div class="d-flex flex-row col-2 justify-content-end p-0 ms-auto m-0 pe-3 flex-nowrap">
                <span class="d-flex text-end text-white mt-1 mb-2 pe-4">
                  <ion-icon name="git-branch" class="tx-18 me-2 align-bottom"></ion-icon>
                  {{ dictionary["Dashboard"][session.user.language] }}
                </span>
              </div>
            </div>
          </div>

          <div class="row col-12 m-0 p-0 bg-black justify-content-center shadow scrollable-content"
            style="height: 95vh;">

            <div class="row col-lg-12 col-xl-12 col-md-12 col-12  pt-0 " style="height: 100%;">
              <div class="col-12 bg-black scroll-hidden" style="height: 100%; overflow-y: auto;">
                <div class="row h-100">
                  <!-- Menu lateral -->
                  <div class="col-2 bg-black p-0 m-0 ps-0" style="min-width:250px;">
                    <div v-if="machineOrganigramLoading" class="d-flex justify-content-center align-items-center"
                      style="height: 95vh;">
                      <div class="spinner-border" role="status">
                        <span class="sr-only"></span>
                      </div>
                    </div>

                    <div v-else class="tree-container pe-3 pt-1 no-selection custom-scrollbar"
                      style="height: 95vh; overflow-y: scroll;">
                      <div v-for="machineOrganigram, i in machineOrganigrams" :key="i">

                        <div v-for="machine in machineOrganigram" :key="machine.id" class="machine3">
                          <div class="bg-lat1 rounded m-0 p-0 pt-2 pb-1 mt-2 d-flex"
                            :style="{ 'background-color': getMachineEstadoColor(machine) }">
                            <span class="toggle-icon" style="font-size: 14px;">
                              <img @click="onCollapseMachine(machine)" v-if="machine.collapsed"
                                src="@/assets/img/add.png" class="material-symbols-rounded ms-2" style="width: 14px;">
                              <img @click="onCollapseMachine(machine)" v-else src="@/assets/img/remove.png"
                                class="material-symbols-rounded ms-2" style="width: 14px;">
                            </span>
                            <h5 class="machine-name3 h6 text-white text-start ps-3 pt-1"
                              :class="getMachineShowWarning(machine) ? 'show-warning' : ''"
                              @click.stop="navigateToMachine(machine.id)"> {{ machine.label }}</h5>
                          </div>

                          <div class="devices-container2 ms-3" v-if="machine.children">
                            <div v-for="device in machine.children" :key="device.id" class="device">
                              <div class="device-header d-flex flex-wrap text-white"
                                :style="{ 'background-color': getDeviceEstadoColor(device) }">

                                <span class="toggle-icon2" style="font-size: 14px;">
                                  <img @click="onCollapseDevice(machine, device)" v-if="device.collapsed"
                                    src="@/assets/img/add.png" class="material-symbols-rounded" style="width: 14px;">
                                  <img @click="onCollapseDevice(machine, device)" v-else src="@/assets/img/remove.png"
                                    class="material-symbols-rounded" style="width: 14px;">
                                </span>
                                <img :src="getMachineImage(device)" class="node-image3 small m-0 ms-1 me-1 p-0"
                                  style="max-width: 30px; -webkit-filter: invert(100%); filter: invert(100%);"
                                  :class="(getDeviceShowWarning(device)) ? 'show-warning' : ''">
                                <h5 class="pt-1" :data-id="device.id">
                                  {{ device.label }}
                                </h5>

                              </div>

                              <div class="subdevices-container1"
                                v-if="!machine.collapsed && !device.collapsed && device.children">
                                <div v-for="subdevice in device.children" :key="subdevice.id" class="subdevice">
                                  <div class="subdevice-header1 text-white ps-0 ms-0"
                                    style="background-color: #03103e;">
                                    <span class="toggle-icon3" style="max-width:6px !important;">
                                      <img @click="onCollapseSubdevice(machine, device, subdevice)"
                                        v-if="subdevice.collapsed" src="@/assets/img/add.png"
                                        class="material-symbols-rounded ms-2" style="width: 14px;">
                                      <img @click="onCollapseSubdevice(machine, device, subdevice)" v-else
                                        src="@/assets/img/remove.png" class="material-symbols-rounded ms-2"
                                        style="width: 14px;">
                                    </span>
                                    <img :src="getDeviceImage(subdevice)" class="node-image3 xsmall ms-3 me-0"
                                      :class="(getSubdeviceShowWarning(subdevice)) ? 'show-warning-subdevice' : 'no-warning-subdevice'">
                                    <h6 class="btnTargetDevice c-pointer pt-2" style="font-size:12px;"
                                      @click.stop="navigateToSubdevice(subdevice.id)" :data-id="subdevice.id">
                                      {{ subdevice.label }}
                                    </h6>
                                    <img :src="getDeviceEstadoImage(subdevice)" class="iconstate2"
                                      alt="Icono dispositivo" style="margin-left: auto; margin-right: 3%;">
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                      </div>

                    </div>
                  </div>
                  <!-- Fin menu lateral -->

                  <!-- espacio principal -->
                  <div class="row col p-0 m-0 ms-3" style="min-width: 400px;">
                    <div class="visual-container p-0 custom-scrollbar" style="height: 95vh; overflow-y: scroll;">
                      <!-- Semaforo de estado -->
                      <div v-if="machineOrganigramLoading"
                        class="d-flex justify-content-center align-items-center h-100">
                        <div class="spinner-border" role="status">
                          <span class="sr-only"></span>
                        </div>
                      </div>

                      <div v-else class="devices-visual no-selection m-0 p-0">

                        <div v-for="machineOrganigram, i in machineOrganigrams" :key="i">

                          <div class="col-12 m-0 p-0 rounded-5" v-for="machine in machineOrganigram"
                            :key="'visual-' + machine.label">
                            <div class="machine-visual p-0 m-0">
                              <div class="machine-header-visual text-white" style="display:none;">
                                <h5 @click.stop="navigateToMachine(machine.id)">
                                  {{ machine.label }}
                                </h5>
                              </div>

                              <div class="row col m-0 p-0">
                                <div class="devices m-0 p-0 bg-black">
                                  <div v-for="device in machine.children" :key="'visual-device-' + device.label"
                                    class="device-card col-12 m-0 p-0 mt-2 rounded-5"
                                    :class="{ 'collapsed': device.collapsed, 'expanded': !device.collapsed }"
                                    style="background-color: #00073e;">

                                    <div class="device-expanded">
                                      <div class="device-header-expanded1">
                                        <div class="device-header bg-black m-0 p-0 rounded-5">
                                          <h4 class="dvexpanded bg-lat1 d-flex flex-row col-12 text-start text-white m-0 p-2 mb-2 ps-3 rounded-5">
                                            {{ device.label }}

                                            <div v-if="device.variables.digital['Mostrar señales']!=undefined && device.variables.digital['Mostrar señales'].value === 'true'" 
                                              class="col-6 d-flex flex-row justify-content-end m-0 ms-auto p-0 gap-2">
                                              <span v-for="digitalSignal in device.variables.digital" :key="digitalSignal.variableId"
                                                :style="(digitalSignal.isConfiguration === 'true' || digitalSignal.distributionGroup === '4')?'display: none !important;':''"
                                                class="d-flex flex-row">
                                                <img
                                                style="height: 18px; margin: 0;"
                                                :src="getSignalImage(digitalSignal)">
                                                <span
                                                  style="height: 18px;"  
                                                  class="d-flex m-0 p-0 ps-1"> 
                                                  {{ digitalSignal.label }}
                                                </span>
                                              </span>
                                            </div>

                                          </h4>
                                          
                                        </div>
                                      </div>
                                    </div>


                                    <div class="row d-flex m-0 p-0" :id="'device-display-' + device.id"
                                      style="background-color: #03103e !important;min-height:18px;">
                                      <div style="background-color: #051950;" class="subdevice-card col-3 p-0 m-0"
                                        v-for="subdevice in device.children"
                                        :key="'visual-subdevice-' + subdevice.label">
                                        <!-- Estado colapsado -->
                                        <div v-if="subdevice.collapsed || device.collapsed || machine.collapsed"
                                          class="subdevice-header-collapsed border border-end-1 border-bottom-0 border-top-0 border-start-0"
                                          style="height: 80px;">
                                          <img :src="getDeviceImage(subdevice)" class="visual-image small pe-4"
                                            :class="(getSubdeviceShowWarning(subdevice)) ? 'show-warning-subdevice' : 'no-warning-subdevice'"
                                            alt="" style="width: 70px; height: auto;">
                                          <h6 class="text-white pt-2 ps-2"
                                            @click.stop="navigateToSubdevice(subdevice.id)">
                                            {{ subdevice.label }}
                                          </h6>
                                          <img :src="getDeviceEstadoImage(subdevice)" class="iconstate" alt=""
                                            style="margin-left: auto; margin-right: 3%; max-width:36px">
                                        </div>

                                        <div v-if="!subdevice.collapsed && !device.collapsed && !machine.collapsed"
                                          class="subdevice-expanded p-0 m-0" style="border-right: solid 1px white; border-bottom: solid 1px white;">
                                          <div class="subdevice-header-expanded">

                                            <div class="col-12 subdevice-image-container p-0 m-0">

                                              <div class="col w-100 p-1 m-auto" 
                                              style="background-color:#00073e; min-height: 350px">
                                                <div class="col-12 justify-content-between p-3 m-0 subdevice-header2"
                                                  style="height: 90px;">
                                                  <img :src="getDeviceImage(subdevice)" class="col-4 m-0 p-2"
                                                    :class="(getSubdeviceShowWarning(subdevice)) ? 'show-warning-subdevice' : 'no-warning-subdevice'"
                                                    alt="Icono subdispositivo"
                                                    @click="onDisplayMantenimiento(subdevice)">
                                                  <div class="col-auto m-0 p-0">
                                                    <h6 class="subdevice-title1 text-white p-2 mt-1 rounded-1"
                                                      :style="{ 'background-color': getSubdeviceEstadoColor(subdevice) }"
                                                      @click.stop="navigateToSubdevice(subdevice.id)">
                                                      {{ subdevice.label }}
                                                    </h6>
                                                  </div>
                                                  <div class="col-auto m-0 p-0 text-center">
                                                    <img
                                                      :src="getBatteryImage(subdevice.variables.analog['Batery']?.value || 0)"
                                                      class="img-fluid me-2" style="width:14px">
                                                    <p class="tx-12 text-white pb-0 mb-0">
                                                      {{ subdevice.variables.analog['Batery']?.value || '-' }}%</p>
                                                  </div>
                                                </div>

                                                <div v-if="subdevice.dclType.toUpperCase().includes('SENSOR')"
                                                  class="col-12 justify-content-center p-0 m-0 pt-3"
                                                  style="background-color: #00073e;">
                                                  <div class="col-12 p-0 m-0 justify-content-center"
                                                    style="z-index: 999;">
                                                    <VueGauge :entityId="subdevice.id"
                                                      :value="Number(subdevice.variables.analog['Presure']?.value) || 0"
                                                      :min="0"
                                                      :max="Number(subdevice.variables.analog['Fondo de escala']?.value || 100)"
                                                      :sectors="sectorsByNode(subdevice)"
                                                      :unit="subdevice.variables.analog['Presure']?.unit || 'bar'" />
                                                  </div>
                                                </div>

                                                <div v-if="subdevice.dclType.toUpperCase().includes('MORDAZA')"
                                                  class="row col-12 justify-content-center p-0 m-auto"
                                                  style="background-color: #00073e;">
                                                  <div 
                                                    class="d-flex flex-wrap d-col col-4 p-0 m-0 justify-content-center align-items-center"
                                                    style="z-index: 999; height: 195px !important;">
                                                    <img :src="getBlockCardImage(subdevice.variables.analog['est']?.value || 0)"
                                                      @click="onDisplayCalibrado(subdevice)"
                                                      class="img-fluid m-auto w-100"/>
                                                  </div>
                                                  <div v-if="(subdevice.variables.digital['Mostrar presión']?.value || 'false' === 'true') || (subdevice.variables.digital['Mostrar medida']?.value || 'false' === 'true')"
                                                    class="col col-8 p-0 m-0 mb-4 pb-4 justify-content-center"
                                                    style="z-index: 999;">
                                                    <VueLine v-if="subdevice.variables.digital['Mostrar presión']?.value || 'false' === 'true'"
                                                      style="max-height: 75px;" 
                                                      :entityId="subdevice.id"
                                                      :value="Number(subdevice.variables.analog['Presure']?.value) || 0"
                                                      :min="0"
                                                      :max="Number(subdevice.variables.analog['Fondo de escala']?.value || 100)"
                                                      :sectors="sectorsByNode(subdevice) || [20, 40, 60, 80, 100]"
                                                      :unit="subdevice.variables.analog['Presure']?.unit || 'bar'" />
                                                    <VueLine v-if="subdevice.variables.digital['Mostrar medida']?.value || 'false' === 'true'"
                                                      style="max-height: 75px;" 
                                                      :entityId="subdevice.id"
                                                      :value="Number(subdevice.variables.analog['Fuerza']?.value) || 0"
                                                      :min="0"
                                                      :max="Number(subdevice.variables.analog['Fondo de escala strength']?.value || 500)"
                                                      :sectors="sectorsByNode(subdevice) || [20, 40, 60, 80, 100]"
                                                      :unit="subdevice.variables.analog['Fuerza']?.unit || 'kN'"
                                                      :decimal="true"/>
                                                  </div>
                                                </div>

                                                <div v-if="subdevice.dclType.toUpperCase().includes('BLOCK')"
                                                  class="row col-12 justify-content-center p-0 m-auto pt-4 pb-4"
                                                  style="background-color: #00073e;">
                                                  <div
                                                    class="d-flex flex-wrap d-col col-4 p-0 m-0 justify-content-center"
                                                    style="z-index: 999;">
                                                    <img :src="getBlockCardImage(subdevice.variables.analog['est']?.value || 0)"
                                                      @click="onDisplayCalibrado(subdevice)"
                                                      class="img-fluid m-auto w-100" />
                                                    <span v-if="String(subdevice.variables.digital['Mostrar medida']?.value || 'true') === 'true'"
                                                      class="text-white m-auto w-100">
                                                      {{ "⇤ ⇥ " + (subdevice.variables.analog['Position']?.value ||
                                                        "0") + (subdevice.variables.analog['Position']?.unit || "mm")}}
                                                    </span>
                                                    <span v-else class="p-3"></span>
                                                  </div>
                                                  <div class="row col-8 p-0 m-0 mt-4 justify-content-center"
                                                    style="z-index: 999;">
                                                    <VueLine :entityId="subdevice.id"
                                                      :value="Number(subdevice.variables.analog['Presure']?.value) || 0"
                                                      :min="0"
                                                      :max="Number(subdevice.variables.analog['Fondo de escala']?.value || 100)"
                                                      :sectors="sectorsByNode(subdevice) || [20, 40, 60, 80, 100]"
                                                      :unit="subdevice.variables.analog['Presure']?.unit || 'bar'" />
                                                  </div>
                                                </div>

                                                <div v-if="subdevice.dclType.toUpperCase().includes('MAK')"
                                                  class="row col-12 justify-content-center p-0 m-0 mt-4 mb-5 pt-1"
                                                  style="background-color: #00073e;">
                                                  <div
                                                    class="d-flex flex-wrap d-col col-10 p-0 m-0 justify-content-center"
                                                    style="z-index: 999;">
                                                    <img
                                                      :src="getMakCardImage(subdevice.variables.analog['est']?.value)"
                                                      class="img-fluid m-auto" style="height: 118px;">
                                                  </div>
                                                  <div
                                                    :class="(getSubdeviceManometerShowWarning(subdevice)) ? 'show-warning-subdevice' : 'no-manometer-warning-subdevice'"
                                                    class="col-auto p-0 m-auto text-center">
                                                    <img src="@/assets/img/MANOMETER.png" class="m-auto"
                                                      style="width:23px">
                                                    <p class="tx-12 tx-white p-0 m-0">
                                                      {{ (subdevice.variables.analog['Presure']?.value || "") + " " +
                                                      subdevice.variables.analog['Presure']?.unit || "bar"}}
                                                    </p>
                                                  </div>
                                                </div>

                                                <div
                                                  class="col-12 d-flex justify-content-between flex-row p-0 m-0 text-center">
                                                  <div class="col-auto p-3 pt-0 pb-0 text-center">
                                                    <img src="@/assets/img/actualizar.png" class="img-fluid"
                                                      style="width:18px">
                                                    <p class="tx-12 p-0 m-0"
                                                      :style="(subdevice.minutesWithoutCommunication != '-' && Number(subdevice.minutesWithoutCommunication) > Number(computeMinutesToWarn(subdevice))) ? 'color: red' : 'color: white'">
                                                      {{ subdevice.minutesWithoutCommunication + " " + "min" }} </p>
                                                  </div>
                                                  <div
                                                    v-if="(subdevice.dclType.toUpperCase().includes('BLOCK')
                                                      || subdevice.dclType.toUpperCase().includes('MAK')
                                                      || subdevice.dclType.toUpperCase().includes('MORDAZA'))
                                                      && subdevice.variables.digital['Detection activated']?.value === 'true'"
                                                    :class="(getSubdeviceDetectionShowWarning(subdevice)) ? 'show-warning-detection-subdevice' : 'no-warning-detection-subdevice'"
                                                    class="col-auto p-3 pt-0 pb-0 text-center">
                                                    <img src="@/assets/img/DETECTION.png" class="m-auto"
                                                      style="width:18px;">
                                                    <p class="tx-12 tx-white p-0 m-0"> 
                                                      {{ "DETECTION" }}
                                                    </p>
                                                  </div>
                                                  <div class="col-auto p-3 pt-0 pb-0 text-center">
                                                    <img
                                                      :src="getTemperatureImage(subdevice.variables.analog['Temperature']?.value || 0)"
                                                      class="img-fluid" style="width:18px">
                                                    <p class="tx-12 text-white p-0 m-0">
                                                      {{ Number(subdevice.variables.analog['Temperature']?.value).toFixed(1)
                                                      || '-'}}Cº</p>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>

                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="row d-flex p-0 m-0" :id="device.dclType"
                                      v-if="!device.collapsed && !machine.collapsed"
                                      style="background-color: #03103e !important; min-height:18px; display:none !important;">
                                      <div style="background-color: #051950;" class="subdevice-card col-3 p-0 m-0"
                                        v-for="subdevice in device.children"
                                        :key="'visual-subdevice-' + subdevice.label">

                                        <!-- Estado colapsado -->
                                        <div class="subdevice-header-collapsed"
                                          v-if="subdevice.collapsed || device.collapsed">
                                          <img :src="getDeviceImage(subdevice)" class="visual-image small"
                                            alt="Icono subdispositivo">
                                          <h5 @click.stop="navigateToSubdevice(subdevice.id)">
                                            {{ subdevice.label }}
                                          </h5>
                                          <img :src="getDeviceEstadoImage(subdevice)" class="iconstate"
                                            alt="Icono dispositivo" style="margin-left: auto; margin-right: 3%;">
                                        </div>

                                        <div class="subdevice-expanded p-0 m-0" style="border-right: solid 1px white; border-bottom: solid 1px white;"
                                          v-if="!subdevice.collapsed">
                                          <div class="subdevice-header-expanded">
                                            <div class="subdevice-image-container">
                                              <div class="subdevice-header2">
                                                <img :src="getDeviceImage(subdevice)"
                                                  :class="(getSubdeviceShowWarning(subdevice)) ? 'show-warning-subdevice' : 'no-warning-subdevice'"
                                                  alt="Icono subdispositivo">
                                                <h5 class="subdevice-title1"
                                                  :style="{ 'background-color': getSubdeviceEstadoColor(subdevice) }"
                                                  @click.stop="navigateToSubdevice(subdevice.id)">
                                                  {{ subdevice.label }}
                                                </h5>
                                              </div>
                                              <div class="subdevice-image-wrapper">
                                                <img :src="getDeviceEstadoImage(subdevice)" class="iconstate1"
                                                  alt="Icono dispositivo" style="margin-left: 2%;">
                                              </div>
                                            </div>

                                            <div class="subdevice-info-container p-0 m-0" v-if="!subdevice.collapsed">
                                              <div class="subdevice-data-visual m-0 p-0"
                                                style="display:none !important">
                                                <!-- Variables analógicas -->
                                              </div>
                                            </div>

                                          </div>
                                        </div>
                                      </div>
                                    </div>

                                  </div>
                                </div>
                              </div>

                            </div>
                          </div>
                        </div>

                      </div>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- MODAL New Machine -->
  <NewMachineModal v-if="display.newMachineModal" :session="session" :dictionary="dictionary" :countries="countries"
    :timeZones="timeZones" :currentCompany="currentCompany" v-on:toggleNewMachineModal="toggleNewMachineModal">
  </NewMachineModal>

  <!-- Configuration CommandCenters -->
  <div v-if="display.configurationView">
    <CommandCentersConfigurationComponent :session="session" :dictionary="dictionary" :countries="countries"
    :visibility="visibility" :timeZones="timeZones" :currentCompany="currentCompany"
      :availableCompanies="availableCompanies" :targetEmplacementId="targetEmplacementId" :typesByCompany="typesByCompany"
      :dataTableOptions="dataTableOptions" v-on:toggleConfigurationView="toggleConfigurationView">
    </CommandCentersConfigurationComponent>
  </div>

  <!-- Mantenimientos CommandCenters -->
  <div v-if="targetMantenimientoEntity != undefined"
    @click="onHideMantenimiento"
    class="w-100 h-100 row p-0 m-0 justify-content-around align-center"
    style="position: absolute; top: 0; left: 0; z-index: 999; background-color: #00000090;">

    <div id="mantenimientoTitle"
    class="col-3 d-flex rounded-5 border-3 bg-lat1 p-3 m-0 mt-auto mb-3"
    @click.stop>
      <text class="text-white tx-26 tx-bold pe-3"> 
        {{ dictionary["Mantenimiento"][session.user.language] }}: 
      </text>
      <text class="text-white tx-26"> 
        {{ targetMantenimientoEntity.label }} 
      </text>
    </div>
    
    <div id="mantenimientos"
    class="row m-0 p-0 justify-content-around">
      <div id="mantenimiento001"
      class="col-3 rounded-5 border-3 bg-lat1 p-3 m-0 mb-auto"
      style="background-color:#00073e;"
      @click.stop>
        <text class="text-white tx-26 tx-bold"> 
          {{ dictionary["Dar grasa"][session.user.language] }} 
        </text>
        <hr class="tx-white">
        <div class="d-flex flex-row flex-nowrap m-0 p-0 w-100 justify-content-between align-text-bottom">
          <span class="tx-white mt-auto mb-1">
            {{ "min: " + "0" + " " + targetMantenimientoEntity.variables.analog['Ciclos grasa']?.unit }}
          </span>
          <span class="tx-white tx-26 tx-bold mt-0 mb-0">
            {{ targetMantenimientoEntity.variables.analog['Ciclos grasa']?.value + " " + targetMantenimientoEntity.variables.analog['Ciclos grasa']?.unit }}
          </span>
          <span class="tx-white mt-auto mb-1">
            {{ "max: " + targetMantenimientoEntity.variables.analog['Max grasa']?.value + " " + targetMantenimientoEntity.variables.analog['Max grasa']?.unit }}
          </span>
        </div>
        <div
          class="rounded-3 m-0 p-0"
          style="height: 1.25rem; overflow: hidden;">
          <progress
            :value="targetMantenimientoEntity.variables.analog['Ciclos grasa']?.value"
            :max="targetMantenimientoEntity.variables.analog['Max grasa']?.value"
            :class="(targetMantenimientoEntity.variables.analog['Ciclos grasa']?.value >= targetMantenimientoEntity.variables.analog['Max grasa']?.value)?'progress-danger':''"
            style="width:100%; height: 100%; padding: 0; margin: 0;">
          </progress>
        </div>
        <hr class="tx-white">
        <div class="d-flex flex-row flex-nowrap m-0 p-0 w-100 justify-content-between align-text-bottom">
          <span class="tx-white mt-auto mb-1">
            {{ "min: " + "0" + " " + targetMantenimientoEntity.variables.analog['Max dias grasa']?.unit }}
          </span>
          <span class="tx-white tx-26 tx-bold mt-0 mb-0">
            {{ (targetMantenimientoEntity.variables.dynamic['Ultima grasa']?.value) ?Math.round((new Date().getTime() - new Date(targetMantenimientoEntity.variables.dynamic['Ultima grasa']?.value).getTime() || '01/01/1999')/(24 * 60 * 60 * 1000)) + " " + targetMantenimientoEntity.variables.analog['Max dias grasa']?.unit : "0 días"}}
          </span>
          <span class="tx-white mt-auto mb-1">
            {{ "max: " + targetMantenimientoEntity.variables.analog['Max dias grasa']?.value + " " + targetMantenimientoEntity.variables.analog['Max dias grasa']?.unit }}
          </span>
        </div>
        <div
        class="rounded-3 m-0 p-0"
        style="height: 1.25rem; overflow: hidden;">
          <progress
            :value="Math.round((new Date().getTime() - new Date(targetMantenimientoEntity.variables.dynamic['Ultima grasa']?.value).getTime() || '01/01/1999')/(24 * 60 * 60 * 1000))"
            :max="targetMantenimientoEntity.variables.analog['Max dias grasa']?.value"
            :class="(Math.round((new Date().getTime() - new Date(targetMantenimientoEntity.variables.dynamic['Ultima grasa']?.value).getTime() || '01/01/1999')/(24 * 60 * 60 * 1000)) >= targetMantenimientoEntity.variables.analog['Max dias grasa']?.value)?'progress-danger':''"
            style="width:100%; height: 100%; padding: 0; margin: 0;">
          </progress>
        </div>
        <hr class="tx-white">
        <button  v-show="isMantenimiento" class="m-0 rounded-3 button p-0 c-pointer" style="height: 2rem;"
        @click="onResetMantenimientoGrasa()">
          {{ dictionary["Reiniciar contador"][session.user.language] }}
        </button>
      </div>

      <div id="mantenimiento002"
      class="col-3 rounded-5 border-3 bg-lat1 p-3 m-0 mb-auto"
      style="background-color:#00073e;"
      @click.stop>
        <text class="text-white tx-26 tx-bold"> 
          {{ dictionary["Desmontaje y Limpieza"][session.user.language] }} 
        </text>
        <hr class="tx-white">
        <div class="d-flex flex-row flex-nowrap m-0 p-0 w-100 justify-content-between align-text-bottom">
          <span class="tx-white mt-auto mb-1">
            {{ "min: " + "0" + " " + targetMantenimientoEntity.variables.analog['Ciclos limpieza']?.unit }}
          </span>
          <span class="tx-white tx-26 tx-bold mt-0 mb-0">
            {{ targetMantenimientoEntity.variables.analog['Ciclos limpieza']?.value + " " + targetMantenimientoEntity.variables.analog['Ciclos limpieza']?.unit }}
          </span>
          <span class="tx-white mt-auto mb-1">
            {{ "max: " + targetMantenimientoEntity.variables.analog['Max limpieza']?.value + " " + targetMantenimientoEntity.variables.analog['Max limpieza']?.unit }}
          </span>
        </div>
        <div
          class="rounded-3 m-0 p-0"
          style="height: 1.1rem; overflow: hidden;">
          <progress
            :value="targetMantenimientoEntity.variables.analog['Ciclos limpieza']?.value"
            :max="targetMantenimientoEntity.variables.analog['Max limpieza']?.value"
            :class="(targetMantenimientoEntity.variables.analog['Ciclos limpieza']?.value >= targetMantenimientoEntity.variables.analog['Max limpieza']?.value)?'progress-danger':''"
            style="width:100%; height: 100%; padding: 0; margin: 0;">
          </progress>
        </div>
        <hr class="tx-white">
        <div class="d-flex flex-row flex-nowrap m-0 p-0 w-100 justify-content-between align-text-bottom">
          <span class="tx-white mt-auto mb-1">
            {{ "min: " + "0" + " " + targetMantenimientoEntity.variables.analog['Max dias limpieza']?.unit }}
          </span>
          <span class="tx-white tx-26 tx-bold mt-0 mb-0">
            {{ (targetMantenimientoEntity.variables.dynamic['Ultima limpieza']?.value) ?Math.round((new Date().getTime() - new Date(targetMantenimientoEntity.variables.dynamic['Ultima limpieza']?.value).getTime() || '01/01/1999')/(24 * 60 * 60 * 1000)) + " " + targetMantenimientoEntity.variables.analog['Max dias limpieza']?.unit : "0 días"}}
          </span>
          <span class="tx-white mt-auto mb-1">
            {{ "max: " + targetMantenimientoEntity.variables.analog['Max dias limpieza']?.value + " " + targetMantenimientoEntity.variables.analog['Max dias limpieza']?.unit }}
          </span>
        </div>
        <div
        class="rounded-3 m-0 p-0"
        style="height: 1.1rem; overflow: hidden;">
          <progress
            :value="Math.round((new Date().getTime() - new Date(targetMantenimientoEntity.variables.dynamic['Ultima limpieza']?.value).getTime() || '01/01/1999')/(24 * 60 * 60 * 1000))"
            :max="targetMantenimientoEntity.variables.analog['Max dias limpieza']?.value"
            :class="(Math.round((new Date().getTime() - new Date(targetMantenimientoEntity.variables.dynamic['Ultima limpieza']?.value).getTime() || '01/01/1999')/(24 * 60 * 60 * 1000)) >= targetMantenimientoEntity.variables.analog['Max dias limpieza']?.value)?'progress-danger':''"
            style="width:100%; height: 100%; padding: 0; margin: 0;">
          </progress>
        </div>
        <hr class="tx-white">
        <button  v-show="isMantenimiento" class="m-0 rounded-3 button p-0 c-pointer" style="height: 2rem;"
        @click="onResetMantenimientoLimpieza()">
          {{ dictionary["Reiniciar contador"][session.user.language] }}
        </button>
      </div>

      <div id="mantenimiento003"
      class="col-3 rounded-5 border-3 bg-lat1 p-3 m-0 mb-auto"
      style="background-color:#00073e;"
      @click.stop>
        <text class="text-white tx-26 tx-bold"> 
          {{ dictionary["Cambio"][session.user.language] }} 
        </text>
        <hr class="tx-white">
        <div class="d-flex flex-row flex-nowrap m-0 p-0 w-100 justify-content-between align-text-bottom">
          <span class="tx-white mt-auto mb-1">
            {{ "min: " + "0" + " " + targetMantenimientoEntity.variables.analog['Ciclos cambio']?.unit }}
          </span>
          <span class="tx-white tx-26 tx-bold mt-0 mb-0">
            {{ targetMantenimientoEntity.variables.analog['Ciclos cambio']?.value + " " + targetMantenimientoEntity.variables.analog['Ciclos cambio']?.unit }}
          </span>
          <span class="tx-white mt-auto mb-1">
            {{ "max: " + targetMantenimientoEntity.variables.analog['Max cambio']?.value + " " + targetMantenimientoEntity.variables.analog['Max cambio']?.unit }}
          </span>
        </div>
        <div
          class="rounded-3 m-0 p-0"
          style="height: 1.25rem; overflow: hidden;">
          <progress
            :value="targetMantenimientoEntity.variables.analog['Ciclos cambio']?.value"
            :max="targetMantenimientoEntity.variables.analog['Max cambio']?.value"
            :class="(targetMantenimientoEntity.variables.analog['Ciclos cambio']?.value >= targetMantenimientoEntity.variables.analog['Max cambio']?.value)?'progress-danger':''"
            style="width:100%; height: 100%; padding: 0; margin: 0;">
          </progress>
        </div>
        <hr class="tx-white">
        <div class="d-flex flex-row flex-nowrap m-0 p-0 w-100 justify-content-between align-text-bottom">
          <span class="tx-white mt-auto mb-1">
            {{ "min: " + "0" + " " + targetMantenimientoEntity.variables.analog['Max dias cambio']?.unit }}
          </span>
          <span class="tx-white tx-26 tx-bold mt-0 mb-0">
            {{ (targetMantenimientoEntity.variables.dynamic['Ultimo cambio']?.value) ?Math.round((new Date().getTime() - new Date(targetMantenimientoEntity.variables.dynamic['Ultimo cambio']?.value).getTime() || '01/01/1999')/(24 * 60 * 60 * 1000)) + " " + targetMantenimientoEntity.variables.analog['Max dias cambio']?.unit : "0 días"}}
          </span>
          <span class="tx-white mt-auto mb-1">
            {{ "max: " + targetMantenimientoEntity.variables.analog['Max dias cambio']?.value + " " + targetMantenimientoEntity.variables.analog['Max dias cambio']?.unit }}
          </span>
        </div>
        <div
        class="rounded-3 m-0 p-0"
        style="height: 1.25rem; overflow: hidden;">
          <progress
            :value="Math.round((new Date().getTime() - new Date(targetMantenimientoEntity.variables.dynamic['Ultimo cambio']?.value).getTime() || '01/01/1999')/(24 * 60 * 60 * 1000))"
            :max="targetMantenimientoEntity.variables.analog['Max dias cambio']?.value"
            :class="(Math.round((new Date().getTime() - new Date(targetMantenimientoEntity.variables.dynamic['Ultimo cambio']?.value).getTime() || '01/01/1999')/(24 * 60 * 60 * 1000)) >= targetMantenimientoEntity.variables.analog['Max dias cambio']?.value)?'progress-danger':''"
            style="width:100%; height: 100%; padding: 0; margin: 0;">
          </progress>
        </div>
        <hr class="tx-white">
        <button  v-show="isMantenimiento" class="m-0 rounded-3 button p-0 c-pointer" style="height: 2rem;"
        @click="onResetMantenimientoCambio()">
          {{ dictionary["Reiniciar contador"][session.user.language] }}
        </button>
      </div>


    </div>

  </div>

  <!-- Calibrados CommandCenters -->
  <div v-if="targetCalibradoEntity != undefined"
    @click="onHideCalibrado"
    class="w-100 h-100 row p-0 m-0 justify-content-around align-center"
    style="position: absolute; top: 0; left: 0; z-index: 999; background-color: #00000090;">

    <div id="CalibradoTitle"
    class="col-3 d-flex rounded-5 border-3 bg-lat1 p-3 m-0 mt-auto mb-3"
    @click.stop>
      <text class="text-white tx-26 tx-bold pe-3"> 
        {{ dictionary["Calibrado"][session.user.language] }}: 
      </text>
      <text class="text-white tx-26"> 
        {{ targetCalibradoEntity.label }} 
      </text>
    </div>

    <div id="mantenimientos"
    class="row m-0 p-0 justify-content-around">
      <div id="calibrado001"
      class="col-3 rounded-5 border-3 bg-lat1 p-3 m-auto mt-0"
      style="background-color:#00073e;"
      @click.stop>
        <text class="text-white tx-26 tx-bold"> 
          {{ dictionary["Estado"][session.user.language] }}: 
        </text>
        <hr class="tx-white">
        <text class="text-white"> 
          {{ dictionary["Selecciona el estado actual del amarre"][session.user.language] }}: 
        </text>
        <br>
        <span class="text-white m-auto w-100">
          {{ "⇤ ⇥ " + (targetCalibradoEntity.variables.analog['Position']?.value ||
            "0") + (targetCalibradoEntity.variables.analog['Position']?.unit || "mm")}}
        </span>
        <div class="d-flex row flex-nowrap m-0 p-0 pt-3">
          <button class="col-5 m-auto p-0 rounded-3 button c-pointer" style="height: 2rem;"
          @click="onResetCalibradoOpen()">
            {{ dictionary["Abierto"][session.user.language] }}
          </button>
          <button class="col-5 m-auto p-0 rounded-3 button c-pointer" style="height: 2rem;"
          @click="onResetCalibradoClose()">
            {{ dictionary["Cerrado"][session.user.language] }}
          </button>
        </div>
      </div>
      
    </div>
  
  </div>

  
</template>

<script>

import 'leaflet.markercluster/dist/MarkerCluster.css';
import 'leaflet.markercluster/dist/MarkerCluster.Default.css';
import CommandCentersConfigurationComponent from '@/components/electricalMonitoring/CommandCentersConfigurationComponent';
import NewMachineModal from '@/components/machines/NewMachineModal';
import api from '@/services/api';
import VueGauge from "@/components/electricalMonitoring/VueGauge.vue";
import VueLine from "@/components/electricalMonitoring/VueLine.vue";

export default {
  name: "DashboradPage",
  components: { NewMachineModal, CommandCentersConfigurationComponent, VueGauge, VueLine },
  props: {
    session: { type: Object, required: true },
    dictionary: { type: Object, required: true },
    countries: { type: Object, required: true },
    timeZones: { type: Object, required: true },
    visibility: { type: Object, required: true },
    currentCompany: { type: Object, required: true },
    availableCompanies: { type: Object, required: true },
    targetEmplacementId: { type: String, required: true },
    dataTableOptions: { type: Object, required: true },
    typesByCompany: { type: Object, required: true },
    isOperario: { type: Boolean, required: true },
    isMantenimiento: { type: Boolean, required: true },
    isFabricante: { type: Boolean, required: true }
  },
  data() {
    return {
      refreshMiliseconds: 1000,
      refreshingThread: 0,
      refreshCount: 0,
      updateInterval: null,
      currentDataHashes: {},
      machineList: [],
      targetEmplacementData: {},
      targetMantenimientoEntity: undefined,
      targetCalibradoEntity: undefined,
      emplacementList: [],
      machineOrganigrams: {},
      machineOrganigramLoading: true,
      priorityById: {},
      presureById: {},
      collapsedById: {},
      collapseAll: false,
      collapseNone: false,
      display: {
        showEverything: true,
        configurationView: false,
        newMachineModal: false,
      },
      priority: "None",
      basePriority: 100,
      stepPriority: 1,
      emplacementLinkedId: '',
      lastLoadedCompany: null,
      isLector: false,
      isGestor: false,
      isEditor: false,
      isAdmin: false
    }
  },
  emits: ["setCurrentCompany", "setEmplacement", "handleHasRol"],
  watch: {
    currentCompany: {
      immediate: true,
      async handler(newVal) {
        if (newVal.nifCif && newVal.nifCif !== this.lastLoadedCompany) {
          this.lastLoadedCompany = newVal.nifCif;
          await this.loadInitialData();
        }
      }
    },
    targetEmplacementId: {
      immediate: true,
      async handler(newVal) {
        if (newVal && newVal !== this.lastLoadedEmplacement) {
          this.lastLoadedEmplacement = newVal;
          this.machineOrganigramLoading = true;
          this.machineOrganigrams = {};
          this.stopAutoRefresh();
          await this.getEmplacementData();
          await this.getMachinesDataByEmplacement();
          this.startAutoRefresh();
        }
      }
    },
    currentUtillajeIndex: {
      immediate: true,
      handler(newIndex) {
        if (this.machineList.length > 0 && newIndex >= 0) {
          this.currentUtillaje = this.machineList[newIndex].label;
        }
      }
    },
  },
  methods: {
    isCollapsed(id) {
      let collapsed = this.collapsedById[id];
      if (this.collapseAll) collapsed = true;
      if (this.collapseNone) collapsed = false;
      if (collapsed == undefined) {
        collapsed = false;
        this.collapsedById[id] = collapsed
      }
      this.collapsedById[id] = collapsed
      localStorage.setItem("ClomosDashboardCollapsedById", JSON.stringify(this.collapsedById));
      return collapsed;
    },

    onCollapseMachine(machine) {
      this.collapseAll = false;
      this.collapseNone = false;
      machine.collapsed = !machine.collapsed;
      this.collapsedById[machine.type + "-" + machine.id] = machine.collapsed;
      //if (machine.collapsed) {
      for (let i in machine.children) {
        let device = machine.children[i];
        device.collapsed = machine.collapsed;
        this.collapsedById[device.type + "-" + device.id] = machine.collapsed;
      }
      //}
      localStorage.setItem("ClomosDashboardCollapsedById", JSON.stringify(this.collapsedById));
    },

    onCollapseDevice(machine, device) {
      this.collapseAll = false;
      this.collapseNone = false;
      device.collapsed = !device.collapsed;
      this.collapsedById[device.type + "-" + device.id] = device.collapsed;
      if (!device.collapsed) {
        machine.collapsed = false;
        this.collapsedById[machine.type + "-" + machine.id] = false;
      }
    },

    onCollapseSubdevice(machine, device, subdevice) {
      this.collapseAll = false;
      this.collapseNone = false;
      subdevice.collapsed = !subdevice.collapsed;
      this.collapsedById[subdevice.type + "-" + subdevice.id] = subdevice.collapsed;
    },

    onCollapseAll() {
      this.collapseAll = true;
      this.collapseNone = false;
    },

    onCollapseNone() {
      this.collapseNone = true;
      this.collapseAll = false;
    },

    onDisplayMantenimiento(entity) {
      if (entity.dclType.toUpperCase().includes('BLOCK')) { this.targetMantenimientoEntity = entity; return }
      if (entity.dclType.toUpperCase().includes('MAK')) { this.targetMantenimientoEntity = entity; return }
      return;
    },

    onHideMantenimiento() {
      this.targetMantenimientoEntity = undefined;
    },

    async onResetMantenimientoGrasa() {
      let ciclosData = {
        "deviceId": this.targetMantenimientoEntity.id,
        "Ciclos grasa": {
          "id": this.targetMantenimientoEntity.variables.analog["Ciclos grasa"].variableId,
          "type": this.targetMantenimientoEntity.variables.analog["Ciclos grasa"].type,
          "value": 0,
        }
      };
      await api.setDeviceVariables(ciclosData);
      let diasData = {
        "deviceId": this.targetMantenimientoEntity.id,
        "Ultima grasa": {
          "id": this.targetMantenimientoEntity.variables.dynamic["Ultima grasa"].variableId,
          "type": this.targetMantenimientoEntity.variables.dynamic["Ultima grasa"].type,
          "value": api.parseDateTimeToString(new Date()),
        }
      };
      await api.setDeviceVariables(diasData);
    },

    async onResetMantenimientoLimpieza() {
      let ciclosData = {
        "deviceId": this.targetMantenimientoEntity.id,
        "Ciclos limpieza": {
          "id": this.targetMantenimientoEntity.variables.analog["Ciclos limpieza"].variableId,
          "type": this.targetMantenimientoEntity.variables.analog["Ciclos limpieza"].type,
          "value": 0,
        }
      };
      await api.setDeviceVariables(ciclosData);
      let diasData = {
        "deviceId": this.targetMantenimientoEntity.id,
        "Ultima limpieza": {
          "id": this.targetMantenimientoEntity.variables.dynamic["Ultima limpieza"].variableId,
          "type": this.targetMantenimientoEntity.variables.dynamic["Ultima limpieza"].type,
          "value": api.parseDateTimeToString(new Date()),
        }
      };
      await api.setDeviceVariables(diasData);
    },

    async onResetMantenimientoCambio() {
      let ciclosData = {
        "deviceId": this.targetMantenimientoEntity.id,
        "Ciclos cambio": {
          "id": this.targetMantenimientoEntity.variables.analog["Ciclos cambio"].variableId,
          "type": this.targetMantenimientoEntity.variables.analog["Ciclos cambio"].type,
          "value": 0,
        }
      };
      await api.setDeviceVariables(ciclosData);
      let diasData = {
        "deviceId": this.targetMantenimientoEntity.id,
        "Ultimo cambio": {
          "id": this.targetMantenimientoEntity.variables.dynamic["Ultimo cambio"].variableId,
          "type": this.targetMantenimientoEntity.variables.dynamic["Ultimo cambio"].type,
          "value": api.parseDateTimeToString(new Date()),
        }
      };
      await api.setDeviceVariables(diasData);
    },

    onDisplayCalibrado(entity) {
      if (!entity.dclType.toUpperCase().includes('BLOCK')) return;
      this.targetCalibradoEntity = entity;
    },

    onHideCalibrado() {
      this.targetCalibradoEntity = undefined;
    },

    async onResetCalibradoOpen(){
      let variablesData = {
        "deviceId": this.targetCalibradoEntity.id,
        "Open position": {
          "id": this.targetCalibradoEntity.variables.analog["Open position"].variableId,
          "type": this.targetCalibradoEntity.variables.analog["Open position"].type,
          "value": this.targetCalibradoEntity.variables.analog['Position'].value
        }
      };
      await api.setDeviceVariables(variablesData);
          this.targetCalibradoEntity = undefined;
    },
    async onResetCalibradoClose(){
      let variablesData = {
        "deviceId": this.targetCalibradoEntity.id,
        "Close position": {
          "id": this.targetCalibradoEntity.variables.analog["Close position"].variableId,
          "type": this.targetCalibradoEntity.variables.analog["Close position"].type,
          "value": this.targetCalibradoEntity.variables.analog['Position'].value
        }
      };
      await api.setDeviceVariables(variablesData);
      this.targetCalibradoEntity = undefined;
    },

    async refreshData() {
      this.isRefreshing = true;
      if (this.refreshingThread > 1) {
        console.log("Demasiadas actualizaciones en curso.");
        return;
      } else if (this.$route.params.currentDisplay!='dashboardcomp') {
        console.log("El dashboard está oculto.")
        return;
      } else {
        console.log("Iniciando nueva actualización.")
      }
      this.refreshingThread += 1;
      try {
        await this.getMachinesDataByEmplacement();
        if (!this.machineList.length) return;
        let newMachineOrganigrams = {};
        for (let i in this.machineList) {
          const currentMachineId = this.machineList[i].variableId;
          let newMachineOrganigram = [];
          let nodesToOrganize = [];
          let processedNodes = new Set();
          //let rootResponse = await api.getMachineData(currentMachineId);
          //let rootNode = api.parseMachineFromResponse(rootResponse);
          let rootNode = this.machineList[i];
          if (rootNode.dclClass === "2") {
            rootNode.nodeLevel = "0";
            nodesToOrganize.push(rootNode);
            const processNodeChildren = async (parentNode, levelPrefix, machineOrganigrams) => {
              if (!parentNode.children) return;
              let ii = 0;
              for (let childId of Object.keys(parentNode.children)) {
                if (processedNodes.has(parentNode.children[childId].variableId)) {
                  console.warn(`Nodo con ID ${parentNode.children[childId].variableId} ya fue procesado`);
                  continue;
                }
                let childResponse, childNode;
                if (parentNode.children[childId].claseDcl === "2") {
                  childResponse = {
                    "status-code": "200",
                    "maquina": parentNode.children[childId]
                  };
                  childNode = api.parseMachineFromResponse(childResponse);
                } else if (parentNode.children[childId].claseDcl === "3") {
                  childResponse = {
                    "status-code": "200",
                    "dispositivo": parentNode.children[childId]
                  };
                  childNode = api.parseDeviceFromResponse(childResponse);
                } else {
                  continue;
                }
                processedNodes.add(childNode.id);
                let currentLevelPath = `${levelPrefix}.${ii}`;
                childNode.nodeLevel = currentLevelPath;
                nodesToOrganize.push(childNode);
                await processNodeChildren(childNode, currentLevelPath, machineOrganigrams);
                ii++;
              }
            };
            await processNodeChildren(rootNode, "0", this.machineOrganigrams);
          }
          for (let node of nodesToOrganize) {
            await this.organizeNode(node, node.nodeLevel, newMachineOrganigram);
          }
          this.sortChildrenRecursively(newMachineOrganigram.children);
          newMachineOrganigrams[currentMachineId] = newMachineOrganigram.children;
        }
        this.machineOrganigrams = newMachineOrganigrams;
        this.machineOrganigramLoading = false;
        this.lastUpdateTime = new Date();
      } catch (error) {
        console.error("Error refreshing data:", error);
      } finally {
        this.isRefreshing = false;
        this.refreshingThread -= 1;
        console.log(this.refreshingThread + " actualizaciones en curso.");
      }
    },

    startAutoRefresh() {
      if (this.updateInterval) {
        console.log('Deteniendo intervalo de actualización existente');
        clearInterval(this.updateInterval);
      }
      this.refreshData();
      this.updateInterval = setInterval(() => {
        this.refreshData();
        this.refreshCount += 1;
        if (this.refreshCount >= 3600) {
          window.location.reload()
        this.refreshCount = 0;
        }
      }, this.refreshMiliseconds);
    },

    stopAutoRefresh() {
      if (this.updateInterval) {
        console.log('Deteniendo la actualización automática');
        clearInterval(this.updateInterval);
        this.updateInterval = null;
      }
    },

    navigateToSubdevice(subdevice) {
      this.$router.push({
        params: { currentModule: "electricalMonitoring", currentDisplay: "device", targetEntity: subdevice }
      });
    },

    navigateToMachine(machine) {
      this.$router.push({
        params: { currentModule: "electricalMonitoring", currentDisplay: "commandCenter", targetEntity: machine }
      });
    },

    getMachineImage(device) {
      if (device.dclType.toUpperCase().includes('PBLOCK')) return require('@/assets/img/machine.png');
      return require('@/assets/img/machine.png');
    },

    getSignalImage(signal) {
      switch(signal.distributionGroup) {
        case "0":
          if (signal.value === "true") return require('@/assets/img/S-ESTADO-1.png');
          return require('@/assets/img/S-ESTADO-0.png');
        case "1":
          if (signal.value === "true") return require('@/assets/img/S-ALARMA-1.png');
          return require('@/assets/img/S-ALARMA-0.png');
        case "2":
          if (signal.value === "true") return require('@/assets/img/S-PILOTO-1.png');
          return require('@/assets/img/S-PILOTO-0.png');
        case "3":
          if (signal.value === "true") return require('@/assets/img/S-AVISO-1.png');
          return require('@/assets/img/S-AVISO-0.png');
        case "4":
          // INVISIBLE
          return;
        default:
          break;
        }
    },

    getMachineEstadoColor(machine) {
      let worst = 0;
      for (let i in machine.children) {
        let device = machine.children[i] || [];
        for (let ii in device.children) {
          const estado = device.children[ii].variables.analog['est']?.value || 0;
          if (worst === 3) { continue }
          if (worst === 4) { if (Number(estado) == 3) worst = 3 }
          if (worst != 3 && worst != 4) { worst = estado }
        }
      }
      if (worst === 0) return '#00073e';
      if (worst === 1) return '#00073e';
      if (worst === 2) return '#00073e';
      if (worst === 3) return '#f60402';
      if (worst === 4) return '#ff8e01';
      return '#00073e';
    },

    getDeviceEstadoColor(device) {
      let worst = 0;
      for (let i in device.children) {
        const estado = device.children[i].variables.analog['est']?.value || 0;
        if (worst === 3) { continue }
        if (worst === 4) { if (Number(estado) == 3) worst = 3 }
        if (worst != 3 && worst != 4) { worst = estado }
      }
      if (worst === 0) return '#00073e';
      if (worst === 1) return '#00073e';
      if (worst === 2) return '#00073e';
      if (worst === 3) return '#f60402';
      if (worst === 4) return '#ff8e01';
      return '#00073e';
    },

    getSubdeviceEstadoColor(subdevice) {
      if (subdevice.dclType.toUpperCase().includes('MAK')) {
        const estado = subdevice.variables.analog['est']?.value || 0;
        if (Number(estado) == 0) return '#00073e'; // ABIERTO OK
        if (Number(estado) == 1) return '#00073e'; // CERRADO OK
        if (Number(estado) == 2) return '#00073e'; // -
        if (Number(estado) == 3) return '#f60402'; // NOK 
        if (Number(estado) == 4) return '#f60402'; // ESTADO NOK = NOK
        return '#f60402';
      }
      if (subdevice.dclType.toUpperCase().includes('BLOCK')) {
        const estado = subdevice.variables.analog['est']?.value || 0;
        if (Number(estado) == 0) return '#00073e'; // ABIERTO OK
        if (Number(estado) == 1) return '#00073e'; // CERRADO OK
        if (Number(estado) == 2) return '#00073e'; // -
        if (Number(estado) == 3) return '#f60402'; // NOK 
        if (Number(estado) == 4) return '#f60402'; // NOK
        return '#f60402';
      }
      if (subdevice.dclType.toUpperCase().includes('SENSOR')) {
        const estado = subdevice.variables.analog['est']?.value || 0;
        if (Number(estado) == 0) return '#00073e'; // ABIERTO OK
        if (Number(estado) == 1) return '#00073e'; // CERRADO OK
        if (Number(estado) == 2) return '#00073e'; // -
        if (Number(estado) == 3) return '#f60402'; // NOK
        if (Number(estado) == 4) return '#f60402'; // NOK
        return '#f60402';
      }
      if (subdevice.dclType.toUpperCase().includes('MORDAZA')) {
        const estado = subdevice.variables.analog['est']?.value || 0;
        if (Number(estado) == 0) return '#00073e'; // ABIERTO OK
        if (Number(estado) == 1) return '#00073e'; // CERRADO OK
        if (Number(estado) == 2) return '#00073e'; // -
        if (Number(estado) == 3) return '#f60402'; // NOK
        if (Number(estado) == 4) return '#f60402'; // NOK
        return '#f60402';
      }
    },

    getMachineShowWarning(machine) {
      let showWarning = false;
      for (let i in machine.children) {
        let device = machine.children[i] || [];
        showWarning = device.children[i]?.showWarning || false;
        if (showWarning) return true;
        for (let ii in device.children) {
          showWarning = device.children[ii].showWarning || false;
          if (showWarning) return true;
        }
      }
      return showWarning;
    },

    getDeviceShowWarning(device) {
      let showWarning = false;
      showWarning = device.showWarning || false;
      if (showWarning) return true;
      for (let i in device.children) {
        showWarning = device.children[i]?.showWarning || false;
        if (showWarning) return true;
      }
      return showWarning;
    },

    getSubdeviceShowWarning(subdevice) {
      return subdevice.showWarning || false;
    },

    getSubdeviceManometerShowWarning(subdevice) {
      let estado = subdevice.variables.analog['est']?.value || 0;
      let presion = subdevice.variables.analog['Presure']?.value || 0;
      let umbralSuperior = subdevice.variables.analog['Umbral superior']?.value || 0;
      let umbralInferior = subdevice.variables.analog['Umbral inferior']?.value || 0;
      let presionCierre = subdevice.variables.analog['Presión de cierre']?.value || 0;
      if (Number(estado) == 0) return false;
      if (Number(estado) == 1) return false;
      if (Number(estado) == 2) return false;
      if (Number(estado) == 3) {
        if ((presion >= umbralInferior && presion <= umbralSuperior) || presion <= presionCierre) return false
        return true;
      }
      if (Number(estado) == 4) {
        if ((presion >= umbralInferior && presion <= umbralSuperior) || presion <= presionCierre) return false
        return true;
      }
    },

    getSubdeviceDetectionShowWarning(subdevice) {
      let showWarning = false;
      if (subdevice.variables.digital["detected"]?.value === 'true'
        && subdevice.variables.digital["Detection activated"]?.value === 'true') {
        showWarning = true
      }
      return showWarning;
    },

    getDeviceImage(subdevice) {
      if (subdevice.dclType.toUpperCase().includes('MAK')) return require('@/assets/img/Fresmak - Iconos - 0MAK.svg');
      if (subdevice.dclType.toUpperCase().includes('BLOCK')) return require('@/assets/img/Fresmak - Iconos - Block SC.svg');
      if (subdevice.dclType.toUpperCase().includes('SENSOR')) return require('@/assets/img/Fresmak - Iconos - Presión.svg');
      if (subdevice.dclType.toUpperCase().includes('MORDAZA')) return require('@/assets/img/Fresmak - Iconos - Mordaza.svg');
      return require('@/assets/img/machine.png');
    },
    
    getDeviceEstadoImage(subdevice) {
      let estado = subdevice.variables.analog['est']?.value || 0;
      if (subdevice.dclType.toUpperCase().includes('MAK')) {
        if (subdevice.variables.analog.est == undefined) return require('@/assets/img/nok.png');
        if (Number(estado) == 0) return require('@/assets/img/ok.png');
        if (Number(estado) == 1) return require('@/assets/img/ok.png');
        if (Number(estado) == 2) return require('@/assets/img/ok.png');
        if (Number(estado) == 3) return require('@/assets/img/nok.png');
        if (Number(estado) == 4) return require('@/assets/img/reg.png');
      }
      if (subdevice.dclType.toUpperCase().includes('BLOCK'))  {
        if (subdevice.variables.analog.est == undefined) return require('@/assets/img/nok.png');
        if (Number(estado) == 0) return require('@/assets/img/ok.png');
        if (Number(estado) == 1) return require('@/assets/img/ok.png');
        if (Number(estado) == 2) return require('@/assets/img/ok.png');
        if (Number(estado) == 3) return require('@/assets/img/nok.png');
        if (Number(estado) == 4) return require('@/assets/img/reg.png');
      }
      if (subdevice.dclType.toUpperCase().includes('SENSOR'))  {
        if (subdevice.variables.analog.est == undefined) return require('@/assets/img/nok.png');
        if (Number(estado) == 0) return require('@/assets/img/ok.png');
        if (Number(estado) == 1) return require('@/assets/img/ok.png');
        if (Number(estado) == 2) return require('@/assets/img/ok.png');
        if (Number(estado) == 3) return require('@/assets/img/nok.png');
        if (Number(estado) == 4) return require('@/assets/img/reg.png');
      }
      if (subdevice.dclType.toUpperCase().includes('MORDAZA'))  {
        if (subdevice.variables.analog.est == undefined) return require('@/assets/img/nok.png');
        if (Number(estado) == 0) return require('@/assets/img/ok.png');
        if (Number(estado) == 1) return require('@/assets/img/ok.png');
        if (Number(estado) == 2) return require('@/assets/img/ok.png');
        if (Number(estado) == 3) return require('@/assets/img/nok.png');
        if (Number(estado) == 4) return require('@/assets/img/reg.png');
      }
      return require('@/assets/img/error.png');
    },

    getBatteryImage(batteryValue) {
      const value = parseFloat(batteryValue);
      if (value > 95) return require('@/assets/img/battery_full.svg');
      if (value >= 80) return require('@/assets/img/battery_6.svg');
      if (value >= 70) return require('@/assets/img/battery_5.svg');
      if (value >= 50) return require('@/assets/img/battery_4.svg');
      if (value >= 35) return require('@/assets/img/battery_3.svg');
      if (value >= 25) return require('@/assets/img/battery_2.svg');
      if (value >= 10) return require('@/assets/img/battery_1.svg');
      if (value < 10) return require('@/assets/img/battery_0.svg');
    },

    getBlockCardImage(status) {
      const value = parseFloat(status);
      if (value == 0) return require('@/assets/img/BLOCK_OPEN.png');
      if (value == 1) return require('@/assets/img/BLOCK_CLOSED.png');
      if (value == 4) return require('@/assets/img/BLOCK_ERROR.png');
      return require('@/assets/img/BLOCK_ERROR.png');
    },

    getMakCardImage(status) {
      const value = parseFloat(status);
      if (value == 0) return require('@/assets/img/MAK_OPEN.png');
      if (value == 1) return require('@/assets/img/MAK_CLOSED.png');
      if (value == 4) return require('@/assets/img/MAK_ERROR.png');
      return require('@/assets/img/MAK_ERROR.png');
    },

    getTemperatureImage(temperatureValue) {
      const value = parseFloat(temperatureValue);
      if (value < 100) return require('@/assets/img/termo-green.png');
      if (value >= 150) return require('@/assets/img/termo-orange.png');
      if (value >= 200) return require('@/assets/img/termo-red.png');
    },

    async loadInitialData() {
      await this.getEmplacementList();
      if (this.$route.params.currentDisplay === 'machines' || this.targetEmplacementId == '') {
        await this.getMachinesDataByCompany();
      } else {
        if (this.emplacementList[0] != undefined) this.targetEmplacementData = this.emplacementList[0];
        await this.getMachinesDataByEmplacement();
      }
    },

    computeWarning(node, minutesWithoutCommunication) {
      if (node.variables.digital['Mostrar aviso'] != undefined) {
        if (node.variables.digital['Mostrar aviso'].value == "false")
          return false;
      }
      let lowBatteryValue = node.variables.analog['Umbral batería baja']?.value || 10
      if ((node.variables.analog['Batery']?.value || 0) <= lowBatteryValue) return true;
      if (minutesWithoutCommunication == "-") return false;
      if (Number(minutesWithoutCommunication) > Number(this.computeMinutesToWarn(node))) return true;
      return false;
    },

    computeMinutesToWarn(node) {
      let minutesToWarn = 0;
      if (node.communicationDateTime != "") {
        let samplesToWarn = node.variables.analog['Muestras de aviso']?.value || 0;
        let samplesToCommunicate = node.variables.analog['Numero de muestras para envío']?.value || 0;
        let sampleRate = (node.variables.analog['Tiempo medida']?.value) || 0;
        minutesToWarn = samplesToCommunicate * sampleRate * samplesToWarn;
      }
      return minutesToWarn
    },

    async organizeNode(node, levelPath, newMachineOrganigram) {
      if (node.id === this.targetMantenimientoEntity?.id) {
        this.targetMantenimientoEntity = node;
      }
      let currentLevel = levelPath.split('.').map(Number);
      let target = newMachineOrganigram;
      for (let i = 0; i < currentLevel.length; i++) {
        const level = currentLevel[i];
        if (!target.children) target.children = [];
        if (!target.children[level]) target.children[level] = { children: [] };
        target = target.children[level];
      }
      let minutesWithoutCommunication = "-";
      if (node.communicationDateTime != "" && node.communicationDateTime != undefined) {
        let communicationDate = new Date(node.communicationDateTime.replace(' ', 'T') + 'Z');
        minutesWithoutCommunication = Math.floor((Date.now() - communicationDate.getTime()) / 1000 / 60);
      }
      let showWarning = this.computeWarning(node, minutesWithoutCommunication);
      let priority = 0;
      Object.assign(target, {
        id: node.id,
        label: node.label,
        type: node.dclClass,
        distributionGroup: node.distributionGroup,
        variables: node.variables,
        minutesWithoutCommunication: minutesWithoutCommunication,
        showWarning: showWarning,
        priority: priority,
      });
      if (target.variables.analog['Presure'] != undefined) {
        if (this.priorityById[target.id] === undefined) {
          this.priorityById[target.id] = this.basePriority;
        }
        if (this.presureById[target.id] === undefined) {
          this.presureById[target.id] = target.variables.analog['Presure'].value;
        }
        if (this.presureById[target.id] != target.variables.analog['Presure'].value) {
          this.priorityById[target.id] = this.priorityById[target.id] + Math.abs(this.presureById[target.id] - target.variables.analog['Presure'].value);
        }
        else {
          let newPriority = this.priorityById[target.id] - this.stepPriority;
          if (newPriority < 0) newPriority = 0;
          this.priorityById[target.id] = newPriority;
        }
        this.presureById[target.id] = target.variables.analog['Presure'].value;
        target.priority = this.priorityById[target.id];
      }
      if (target.variables.analog['Batery'] != undefined) {
        let batteryCap = ((target.variables.analog['Batery']?.value || 0) > 100) ? 100 : target.variables.analog['Batery']?.value;
        target.variables.analog['Batery'].value = batteryCap;
      }
      if (node.dclClass === "2") {
        let dclType = this.typesByCompany?.machineTypeList?.filter(type => type.id === node.dclTypeId);
        target.dclType = dclType && dclType.length > 0 ? dclType[0].label : "";
        target.collapsed = this.isCollapsed("2-" + node.id);
      } else if (node.dclClass === "3") {
        let dclType = this.typesByCompany?.deviceTypeList?.filter(type => type.id === node.dclTypeId);
        target.dclType = dclType && dclType.length > 0 ? dclType[0].label : "";
        target.collapsed = this.isCollapsed("3-" + node.id);
      }
    },

    sortChildrenRecursively(node) {
      if (Array.isArray(node)) {
        node.forEach(child => this.sortChildrenRecursively(child));
        node.sort((a, b) => this.compareNodes(a, b));
        return;
      }
      if (node.children && node.children.length > 0) {
        node.children.forEach(child => this.sortChildrenRecursively(child));
        node.priority = Math.max(...node.children.map(c => c.priority || 0));
        node.children.sort((a, b) => this.compareNodes(a, b));
      }
    },

    compareNodes(a, b) {
      if (this.priority === "Warning") {
        if (a.showWarning && (!b.showWarning || a.minutesWithoutCommunication < b.minutesWithoutCommunication)) {
          return 1;
        }
        if (b.showWarning && (!a.showWarning || b.minutesWithoutCommunication < a.minutesWithoutCommunication)) {
          return -1;
        }
      } else if (this.priority === "Presure") {
        if (a.priority > b.priority) return -1;
        if (b.priority > a.priority) return 1;
      }
      const groupA = Number(a.distributionGroup) || 0;
      const groupB = Number(b.distributionGroup) || 0;
      if (groupA !== groupB) return groupA - groupB;

      return (a.label || "").localeCompare(b.label || "");
    },

    sectorsByNode(node) {
      let sectors = [];
      try {
        sectors = [
          node.variables.analog['Umbral mínimo']?.value || 20,
          node.variables.analog['Umbral inferior']?.value || 40,
          node.variables.analog['Umbral superior']?.value || 60,
          node.variables.analog['Umbral máximo']?.value || 80,
          node.variables.analog['Fondo de escala']?.value || 100
        ];
      } catch {
        let max = 100;
        sectors = [
          (max / 5) * 1,
          (max / 5) * 2,
          (max / 5) * 3,
          (max / 5) * 4,
          max,
        ];
      }
      return sectors;
    },

    onCurrentCompanyChanged(event) {
      let value = event.target.value;
      this.$router.replace({ params: { currentCompanyNifCif: value } });
      this.$emit('setCurrentCompany', value);
      localStorage.setItem("ClomosDashboardTargetCompany", value)
    },

    onEmplacementChanged(event) {
      let value = event.target.value;
      this.$emit('setEmplacement', value);
      localStorage.setItem("ClomosDashboardTargetEmplacement", value)
    },

    onPriorityChanged(event) {
      let value = event.target.value;
      this.priority = value;
      localStorage.setItem("ClomosDashboardTargetPriority", value)
    },

    async toggleNewMachineModal() {
      this.display.newMachineModal = !this.display.newMachineModal;
      if (!this.display.newMachineModal) {
        await this.loadInitialData();
      }
    },

    async getMachinesDataByCompany() {
      this.machineList = [];

      if (this.collapsedById == undefined) this.collapsedById = {};

      let request = {
        nifCif: this.currentCompany.nifCif,
        limit: 0,
        offset: 0,
        where: "",
      };
      let response = await api.getMachineListByCompany(request);
      this.machineList = api.parseMachinesFromResponse(response);
    },

    async getMachinesDataByEmplacement() {
      this.machineList = [];

      if (this.collapsedById == undefined) this.collapsedById = {};

      let request = {
        emplacementId: this.targetEmplacementId,
        limit: 0,
        offset: 0,
        where: "",
      };

      let response = await api.getMachineTreeByEmplacement(request);

      if (response["maquinas"] != undefined) {
        this.flattenNodes(response["maquinas"]);
      }
      this.machineList = api.parseMachinesFromResponse(response);
    },
    
    flattenNodes(nodes) {
      for (const node of nodes) {
        if (!node?.hijos || typeof node.hijos !== "object") continue;
        const newHijos = {};

        for (const [childId, child] of Object.entries(node.hijos)) {
          const rawValue = child.VariablesDigitales?.["Mostrar presión"]?.valor;
          const showPressure =
            rawValue === undefined || String(rawValue).toLowerCase() === "true";
            
          if (child.claseDcl === "4") {
            if (child.hijos && typeof child.hijos === "object") {
              for (const [gcId, gc] of Object.entries(child.hijos)) {
                const isSensor =
                  typeof gc.idTipoDcl === "string" &&
                  gc.idTipoDcl.toUpperCase().includes('SENSOR');
                if (!isSensor || showPressure) {
                  newHijos[gcId] = gc;
                }
              }
            }
            continue;
          }

          if (child.claseDcl === "2" && child.hijos) {
            const filtered = {};
            for (const [gcId, gc] of Object.entries(child.hijos)) {
              const isSensor =
                typeof gc.idTipoDcl === "string" &&
                gc.idTipoDcl.toUpperCase().includes('SENSOR');
              if (!isSensor || showPressure) {
                filtered[gcId] = gc;
              }
            }
            child.hijos = filtered;
          }

          newHijos[childId] = child;
        }

        node.hijos = newHijos;
        this.flattenNodes(Object.values(node.hijos));
      }
    },

    async getEmplacementData() {
      let response = await api.getEmplacementData(this.targetEmplacementId);
      this.targetEmplacementData = api.parseEmplacementFromResponse(response);
    },

    async getEmplacementList() {
      let request = {
        nifCif: this.currentCompany.nifCif,
        limit: 0,
        offset: 0,
        where: "",
      };

      let response = await api.getEmplacementList(request);
      this.emplacementList = api.parseEmplacementsFromResponse(response);
      let cachedEmplacementInEmplacementList = false;
      for (let i in this.emplacementList) {
        if ((localStorage.getItem("ClomosDashboardTargetEmplacement") || "") === "") {
          break
        }
        if (this.emplacementList[i].id === localStorage.getItem("ClomosDashboardTargetEmplacement")) {
          cachedEmplacementInEmplacementList = true;
          break;
        }
      }
      if (cachedEmplacementInEmplacementList) {
        this.$emit('setEmplacement', localStorage.getItem("ClomosDashboardTargetEmplacement"));
        this.emplacementLinkedId = localStorage.getItem("ClomosDashboardTargetEmplacement");
      } else {
        this.$emit('setEmplacement', this.emplacementList[0]?.id || '');
        this.emplacementLinkedId = this.emplacementList[0]?.id || '';
      }
    }
  },
  async created() {
    let startTargetCompany = localStorage.getItem("ClomosDashboardTargetCompany")
    let startTargetEmplacement = localStorage.getItem("ClomosDashboardTargetEmplacement")
    let startTargetPriority = localStorage.getItem("ClomosDashboardTargetPriority")
    let startCollapsedById = localStorage.getItem("ClomosDashboardCollapsedById")
    
    if (startTargetCompany != undefined) this.$emit("setCurrentCompany", startTargetCompany);
    if (startTargetEmplacement != undefined) this.$emit("setEmplacement", startTargetEmplacement);
    if (startTargetPriority != undefined) this.priority = startTargetPriority;
    if (startCollapsedById != undefined) this.collapsedById = JSON.parse(startCollapsedById);

    const currentDisplay = this.$route.params.currentDisplay;
    const module = this.$route.params.currentModule;
    const moduleData = JSON.parse(localStorage.getItem(module));

    if (moduleData && moduleData[currentDisplay]) {
      const storedData = moduleData[currentDisplay];
      if (storedData.displayType !== undefined) {
        this.displayType = storedData.displayType;
      }
    }

    if (this.$route.path.includes('dashboardcomp')) {
      const path = this.$route.path;
      const commandCenterId = path.split('dashboardcomp/')[1];
      if (commandCenterId) {
        this.emplacementLinkedId = commandCenterId;
      }
    }
  },

  beforeUnmount() {
    this.stopAutoRefresh();
  }
}
</script>

<style>
.btnTargetMachine:hover,
.btnTargetDevice:hover,
.btnLinkMachine:hover,
.btnUnlinkMachine:hover,
.btnEditMachine:hover,
.btnDeleteMachine:hover {
  color: #999999 !important;
}

#cardLabel:hover {
  color: var(--main-white) !important;
}

.node {
  width: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
}

.node-top {
  width: 100%;
  padding: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: white;
  border-radius: 5px 5px 0 0;
}

.node-bot {
  width: 100%;
  padding: 0;
  display: flex;
  flex-direction: row;
  align-items: start;
  justify-content: center;
  color: black;
  border-radius: 0 0 5px 5px;
}

.show-warning {
  z-index: 9;
  transform: scale(1);
  animation: pulse 2s infinite;
}

.show-warning-subdevice {
  z-index: 9;
  transform: scale(1);
  animation: pulse 2s infinite;
  filter: brightness(0) saturate(100%) invert(32%) sepia(88%) saturate(7455%) hue-rotate(356deg) brightness(106%) contrast(120%)
}

.no-warning-subdevice {
  z-index: 9;
  filter: invert(100%);
  transform: scale(1);
}

.show-warning-detection-subdevice {
  z-index: 9;
  transform: scale(1);
  animation: pulse 2s infinite;
  filter: brightness(0) saturate(100%) invert(32%) sepia(88%) saturate(7455%) hue-rotate(356deg) brightness(106%) contrast(120%)
}

.no-warning-detection-subdevice {
  z-index: 9;
  transform: scale(1);
}

table.dataTable tbody th,
table.dataTable tbody td {
  padding: 1px 3px !important;
  /* e.g. change 8x to 4px here */
}

@keyframes pulse {
  0% {
    opacity: 1.0;
    transform: scale(1.0);
  }

  50% {
    opacity: 0.0;
    transform: scale(0.75);
  }

  100% {
    opacity: 1.0;
    transform: scale(1.0);
  }
}

.custom-scrollbar::-webkit-scrollbar {
  width: 0;
  height: 0;
  background: transparent;
}

.custom-scrollbar::-webkit-scrollbar-track {
  background: transparent;
}

.custom-scrollbar::-webkit-scrollbar-thumb {
  background: transparent;
}

.custom-scrollbar::-webkit-scrollbar-corner {
  background: transparent;
}

progress {
    color: #05b80b;
    background: lightgrey;
}

.progress-danger {
    color: #8f060f;
    background: lightgrey;
}

progress::-moz-progress-bar {
    background: currentColor;
}

progress::-webkit-progress-bar {
    background: lightgrey;
}

progress::-webkit-progress-value {
    background: currentColor;
}
</style>